import {
  ArrowCircleRight,
  ArrowDown,
  ArrowLeft,
  ArrowsClockwise,
  ArrowsIn,
  ArrowsOut,
  BellSimpleRinging,
  CaretDown,
  CaretRight,
  Check,
  CheckCircle,
  CircleNotch,
  CirclesThreePlus,
  Code,
  Copy,
  Eye,
  EyeSlash,
  FileText,
  Gear,
  GridFour,
  House,
  Info,
  LockSimpleOpen,
  MagnifyingGlass,
  Minus,
  Pencil,
  Play,
  Plus,
  PlusCircle,
  Question,
  TerminalWindow,
  Trash,
  TrashSimple,
  Upload,
  UploadSimple,
  UserCircle,
  Warning,
  WarningCircle,
  X,
  XCircle,
  type Icon as PhosphorIcon,
} from '@phosphor-icons/react';

export type Icon = PhosphorIcon;

export const Icons = {
  arrowCircleRight: ArrowCircleRight,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowsClockwise: ArrowsClockwise,
  arrowsIn: ArrowsIn,
  arrowsOut: ArrowsOut,
  bellSimpleRinging: BellSimpleRinging,
  caretDown: CaretDown,
  caretRight: CaretRight,
  check: Check,
  checkCircle: CheckCircle,
  circlesThreePlus: CirclesThreePlus,
  code: Code,
  copy: Copy,
  eye: Eye,
  eyeSlash: EyeSlash,
  fileText: FileText,
  gear: Gear,
  gridFour: GridFour,
  house: House,
  info: Info,
  lockSimpleOpen: LockSimpleOpen,
  magnifyingGlass: MagnifyingGlass,
  minus: Minus,
  pencil: Pencil,
  play: Play,
  plus: Plus,
  plusCircle: PlusCircle,
  question: Question,
  spinner: CircleNotch,
  terminalWindow: TerminalWindow,
  trash: Trash,
  trashSimple: TrashSimple,
  upload: Upload,
  uploadSimple: UploadSimple,
  userCircle: UserCircle,
  warningCircle: WarningCircle,
  warning: Warning,
  x: X,
  xCircle: XCircle,
};
